<template>
  <div class="app-navbar-actions" :class="{ 'app-navbar-actions--mobile': isMobile }">
    <v-btn
      v-if="!isMobile"
      variant="text"
      href="https://netlyze.io"
      target="_blank"
      color="secondary"
      class="app-navbar-actions__link"
      prepend-icon="info"
    >
      About Netlyze
    </v-btn>

    <NotificationDropdown class="app-navbar-actions__item app-navbar-actions__item--notification" />

    <StoreSwitcher class="app-navbar-actions__store" />

    <span
      v-if="!isMobile && shopName && !(isUserAccount && userStores.length > 0)"
      class="app-navbar-actions__shop-name"
    >
      {{ shopName }}
    </span>

    <NavbarCurrencySelect class="app-navbar-actions__item app-navbar-actions__item--currency" />

    <ProfileDropdown class="app-navbar-actions__item app-navbar-actions__item--profile" />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useUserStore } from '../../../stores/user-store'
import { useAuthStore } from '../../../stores/auth-store'
import { authService } from '../../../services/auth'
import NavbarCurrencySelect from './NavbarCurrencySelect.vue'
import ProfileDropdown from './dropdowns/ProfileDropdown.vue'
import NotificationDropdown from './dropdowns/NotificationDropdown.vue'
import StoreSwitcher from '../../store/StoreSwitcher.vue'

defineProps({
  isMobile: { type: Boolean, default: false },
})

const { shopName } = storeToRefs(useUserStore())
const authStore = useAuthStore()
const { userStores } = storeToRefs(authStore)

const isUserAccount = computed(() => authService.isUserToken())
</script>

<style lang="scss" scoped>
.app-navbar-actions {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 0.25rem;
  min-width: 0;

  &__link {
    flex-shrink: 0;
    text-transform: none;
    letter-spacing: normal;
    font-weight: 500;
  }

  &__item {
    flex-shrink: 0;
  }

  &__store {
    flex-shrink: 1;
    min-width: 0;
    max-width: 220px;
  }

  &__shop-name {
    font-size: 0.9375rem;
    font-weight: 500;
    color: rgb(var(--v-theme-text-primary));
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 180px;
    padding: 0 0.25rem;
  }

  &__item--profile {
    margin-left: 0.125rem;
  }

  &--mobile {
    gap: 0.2rem;

    .app-navbar-actions__store {
      flex: 0 1 auto;
      min-width: 6.5rem;
      max-width: 8.25rem;
    }

    .app-navbar-actions__item--notification,
    .app-navbar-actions__item--currency,
    .app-navbar-actions__item--profile {
      flex-shrink: 0;
      margin-left: 0;
    }
  }
}
</style>
